var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.75H27V16.25H11V17.75Z",
    fill: "#6F757C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.75H11V20.25H27V21.75Z",
    fill: "#6F757C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.75H17V24.25H11V25.75Z",
    fill: "#6F757C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30888 4.25C6.66846 1.98301 8.63185 0.25 11 0.25C13.3682 0.25 15.3315 1.98301 15.6911 4.25H19.3089C19.6685 1.98301 21.6318 0.25 24 0.25C26.3682 0.25 28.3315 1.98301 28.6911 4.25H29C30.5188 4.25 31.75 5.48122 31.75 7V29C31.75 30.5188 30.5188 31.75 29 31.75H3C1.48122 31.75 0.25 30.5188 0.25 29V7C0.25 5.48122 1.48122 4.25 3 4.25H6.30888ZM7.83697 4.25C8.17555 2.81665 9.46321 1.75 11 1.75C12.5368 1.75 13.8245 2.81665 14.163 4.25H7.83697ZM24 1.75C25.5368 1.75 26.8245 2.81665 27.163 4.25H20.837C21.1755 2.81665 22.4632 1.75 24 1.75ZM15.6911 5.75H27.163C26.8245 7.18335 25.5368 8.25 24 8.25C23.5858 8.25 23.25 8.58579 23.25 9C23.25 9.41421 23.5858 9.75 24 9.75C26.3682 9.75 28.3315 8.01699 28.6911 5.75H29C29.6904 5.75 30.25 6.30964 30.25 7V11.25L7.75 11.25V7C7.75 6.30964 8.30964 5.75 9 5.75H14.163C13.8245 7.18335 12.5368 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9C10.25 9.41421 10.5858 9.75 11 9.75C13.3682 9.75 15.3315 8.01699 15.6911 5.75ZM3.54985 5.75H3C2.30964 5.75 1.75 6.30964 1.75 7V29C1.75 29.6904 2.30964 30.25 3 30.25H3.54985C3.35814 29.875 3.25 29.4501 3.25 29V7C3.25 6.54989 3.35814 6.12503 3.54985 5.75ZM6 30.25C5.30964 30.25 4.75 29.6904 4.75 29V7C4.75 6.30964 5.30964 5.75 6 5.75H6.54985C6.35814 6.12503 6.25 6.54989 6.25 7V29C6.25 29.4501 6.35814 29.875 6.54985 30.25H6ZM7.75 29C7.75 29.6904 8.30964 30.25 9 30.25H29C29.6904 30.25 30.25 29.6904 30.25 29V12.75L7.75 12.75V29Z",
    fill: "#6F757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.2b06d51b2b1783de22ac20c43ba1f072.svg";
export { ForwardRef as ReactComponent };